export const removeToken = () => {
  localStorage.removeItem('token')
}

export const setToken = token => {
  localStorage.setItem('token', token)
}

export const getToken = () => {
  return localStorage.getItem('token')
}

export const getTokenFromLocalStorage = () => {
  const tokenObj = localStorage.getItem('@token')
  if (tokenObj) {
    return JSON.parse(tokenObj).token
  }
  return null
}

export default { setToken, removeToken, getToken }
